import {
  GET_CUSTOMER_COMPLAINTS_REQUESTED,
  GET_CUSTOMER_COMPLAINTS_SUCCESS,
  GET_CUSTOMER_COMPLAINTS_FAILED,
} from "resources/actionTypes";

const initialState = {
  userCustomerComplaints: null,
  loading: false,
  error: null,
};

export function userCustomerComplaints(state = initialState, action) {
  switch (action.type) {
    case GET_CUSTOMER_COMPLAINTS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_CUSTOMER_COMPLAINTS_SUCCESS:
      return {
        ...state,
        loading: false,
        userCustomerComplaints: action.customerComplaints,
      };
    case GET_CUSTOMER_COMPLAINTS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}